import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBalancingPictures } from "../../balancingSelectors/selectBalancingPictures";
import { ScrollOptions } from "../../constants/ScrollOptions";
import { IdStyles } from "../../less/IdStyles";
import { selectOwnedPicturesId } from "../../selectors/selectInventoryInfo";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { actionModalClose, actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { ProfilePicture } from "../player-profile/ProfilePicture";
import { actionPlayerProfilePictureSet } from "./actionPlayerProfilePicture";
export var _DialogSelectPlayerProfilePicture = function (_a) {
    var ownedPictures = _a.ownedPictures, onClose = _a.onClose, onProfilePictureClick = _a.onProfilePictureClick, currentPicture = _a.currentPicture, onInfoClick = _a.onInfoClick;
    var pictures = Array.from(selectBalancingPictures().values());
    var renderedPictures = pictures.map(function (picture) {
        var isLocked = ownedPictures.indexOf(picture.id) < 0;
        var selected = currentPicture === picture.id ? IdStyles.StateSelected : "";
        var onClick = isLocked ? undefined : function () { return onProfilePictureClick(picture.id); };
        return (React.createElement("div", { className: IdStyles.ProfilePictureWrapper + " flex flex--guts profile-pictures__selectable-picture " + selected },
            React.createElement("div", { className: IdStyles.ProfilePictureContainer + " " + selected },
                React.createElement(ProfilePicture, { profilePictureSize: IdStyles.ProfilePictureSmall, profilePictureName: picture.assetName, profilePictureClassName: "profile-pictures__container-item", onClick: onClick }, isLocked && (React.createElement("div", { className: "profile-pictures__locked flex flex--guts", key: "profile-picture_" + picture.id }))))));
    });
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.selectProfilePictureTitle, onClose: function () { return onClose(IdModal.PlayerProfilePictureSelection); }, className: "" + IdStyles.ModalBackgroundInfo, onInfoClick: function () { return onInfoClick(IdModal.PlayerProfilePictureSelectionInfo); } },
        React.createElement("div", { className: "w100 h100 flex flex--around flex--aligned flex--stacked" },
            React.createElement("div", { className: "w100 profile-pictures__scroll-container" },
                React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100 flex flex--wrap flex--left profile-pictures__scroller" }, renderedPictures)))));
};
var mapState = function (state) { return ({
    currentPicture: selectPlayerInfo(state).profilePictureId,
    ownedPictures: selectOwnedPicturesId(state),
}); };
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClose: actionModalClose,
        onInfoClick: actionModalOpen,
        onProfilePictureClick: actionPlayerProfilePictureSet,
    }, dispatch);
};
export var DialogSelectPlayerProfilePicture = connect(mapState, mapDispatch)(_DialogSelectPlayerProfilePicture);



//////////////////
// WEBPACK FOOTER
// ./src/features/profile-picture/DialogSelectPlayerProfilePicture.tsx
// module id = 2882
// module chunks = 3